import { createSelector } from 'reselect';

import getBuffer from './getBuffer';

export default createSelector([getBuffer], buffer =>
  Boolean(buffer.readyToApply),
);
